import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import { getKYC, updateKYC } from '../../actions/settings';

import LegalForm from '../../components/settings/LegalForm';
import LegalSuccess from '../../components/settings/LegalSuccess';

import Loader from '~/common/components/Loader';

class SettingsLegal extends React.Component<any, any> {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getKYC());
  }

  onSubmit = (data) => {
    const { dispatch } = this.props;

    // TODO: Confirmation
    return dispatch(updateKYC(data));
  };

  render() {
    const { loading, onboarded, errorMessage, data } = this.props;

    if (loading) {
      return (
        <Loader className="load--full" />
      );
    }

    const initialValues = data || {};

    if (onboarded) {
      return (
        <LegalSuccess />
      );
    }

    return (
      <LegalForm
        initialValues={initialValues}
        onSubmit={this.onSubmit}
        message={errorMessage}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.shared.settings.kyc.loading,
    onboarded: state.shared.settings.kyc.onboarded,
    errorMessage: state.shared.settings.kyc.errorMessage,
    data: state.shared.settings.kyc.cleanedData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsLegal) as any;
